module.exports = __webpack_public_path__ + "static/RGPDHome-739c4da5a8c82b541042e3d9d93e9b15.png";